// extracted by mini-css-extract-plugin
module.exports = {"buttonNewLaunchDiv":"launchpage_buttonNewLaunchDiv__3wySc","buttonNewLaunch":"launchpage_buttonNewLaunch__prBfZ"};